// components/ai/AIDashboard.tsx
"use client";

import React, { useState } from "react";
import {
  SparklesIcon,
  HeartIcon,
  FireIcon,
  MoonIcon,
  LightBulbIcon,
} from "@heroicons/react/24/outline";
import HuggingFaceChatBox from "./HuggingFaceChatBox";

const QUICK_ACTIONS = [
  {
    label: "Yoga Routine",
    icon: HeartIcon,
    prompt: "Create a 20-minute yoga routine for me based on flexibility and stress relief. Include pose names, hold durations, and breathing cues.",
    color: "bg-orange-50 text-orange-600 border-orange-100 hover:bg-orange-100",
  },
  {
    label: "Meal Plan",
    icon: LightBulbIcon,
    prompt: "Create a healthy vegetarian meal plan for today with breakfast, lunch, dinner and one snack. Include calories and macro estimates.",
    color: "bg-emerald-50 text-emerald-600 border-emerald-100 hover:bg-emerald-100",
  },
  {
    label: "Workout Plan",
    icon: FireIcon,
    prompt: "Design a 30-minute full-body workout for intermediate level. Include exercises, sets, reps, rest periods, and form tips.",
    color: "bg-rose-50 text-rose-600 border-rose-100 hover:bg-rose-100",
  },
  {
    label: "Help Me Sleep",
    icon: MoonIcon,
    prompt: "Give me a calming bedtime routine with breathing exercises, gentle stretches, and sleep hygiene tips I can do in 15 minutes.",
    color: "bg-indigo-50 text-indigo-600 border-indigo-100 hover:bg-indigo-100",
  },
];

interface AIDashboardProps {
  className?: string;
  initialQuery?: string | null;
  compact?: boolean;
}

const AIDashboard: React.FC<AIDashboardProps> = ({
  className = "",
  initialQuery = null,
  compact = false,
}) => {
  const [externalChatMessage, setExternalChatMessage] = useState<string | null>(null);
  const [hasInteracted, setHasInteracted] = useState(false);

  const handleQuickAction = (prompt: string) => {
    setExternalChatMessage(prompt);
    setHasInteracted(true);
  };

  return (
    <div className={`relative flex flex-col gap-4 w-full max-w-5xl mx-auto ${compact ? "h-full" : ""} ${className}`}>

      {/* Quick Actions — full-page only, visible until user starts chatting
      {!compact && !hasInteracted && (
        <div className="animate-in fade-in slide-in-from-bottom-2 duration-500 shrink-0">
          <div className="flex items-center gap-2 mb-3">
            <SparklesIcon className="h-4 w-4 text-orange-500" />
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Quick actions</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {QUICK_ACTIONS.map((action) => (
              <button
                key={action.label} 
                onClick={() => handleQuickAction(action.prompt)}
                className={`group flex items-center gap-2.5 px-4 py-3.5 rounded-2xl border text-left transition-all duration-200 active:scale-[0.97] ${action.color}`}
              >
                <action.icon className="h-5 w-5 shrink-0 opacity-80 group-hover:opacity-100 transition-opacity" />
                <span className="text-sm font-semibold leading-tight">{action.label}</span>
              </button>
            ))}
          </div>
        </div>
      )} */}

      {/* Chat */}
      <div
        className={compact ? "flex-1 min-h-0 w-full" : "w-full"}
        style={compact ? undefined : {
          height: hasInteracted ? "calc(100vh - 280px)" : "calc(100vh - 320px)",
          minHeight: "500px",
          maxHeight: "800px",
        }}
      >
        <HuggingFaceChatBox
          className="h-full rounded-2xl border border-orange-100/60 shadow-[0_4px_24px_rgba(251,146,60,0.06)]"
          initialQuery={initialQuery}
          externalTrigger={externalChatMessage}
        />
      </div>
    </div>
  );
};

export default AIDashboard;
